<!-- Slider main container -->
<button mat-icon-button id="date-button-prev" (click)="onPrev()">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
<div class="dates-wrapper" *ngIf="(isApptLoading$ | async) && (isVehiclesLoading$ | async); else loader">
  <div class="dates" #timeCarousel *ngIf='(appointmentsForDay?.length > 0)'>
    <div class="date" #timeDiv *ngFor="let time of getAppointmentsForTime(); let i = index">
      <div class="time-text"> {{time.timeSlotId}}</div>
      <div *ngIf="department === 'SERVICE'">
        <div *ngFor="let team of teamList" style="margin: 5px;"
          [ngStyle]="{'background': getApptForTeam(time.appointments,team).length === 0 ? '#D1D2D333 0% 0% no-repeat padding-box' : 'white 0% 0% no-repeat padding-box' }">
          <div class="team-name" style="background-color: white;"
            [ngStyle]="{'display' : isApptAvailable(team, 'team', null) ? 'block' : 'none', 'height': i === currentSlide ? '' : '42px' }">
            {{ i === currentSlide ? team.name : ''}} {{ i === currentSlide ? apptCountForTeam(team) : ''}}{{ i ===
            currentSlide && team.id !== 'OTHER' ? '/' + teamMaxSlot(team.id) : ''}} <span
              style="font-family: var(--font-family) ;"> {{i === currentSlide ? (apptCountForTeam(team) > 1 ? 
                ('serviceSchedule.slotsBooked' | translate) : ('serviceSchedule.slotBooked' | translate)) : ''}} </span>
            <span class="tooltiptext">{{ i === currentSlide ? team.name : ''}} {{ i === currentSlide ?
              apptCountForTeam(team) : ''}}{{ i === currentSlide && team.id !== 'OTHER' ? '/' + teamMaxSlot(team.id) :
              ''}} {{i === currentSlide ? ('serviceSchedule.slotsBooked' | translate) : ''}}</span>
          </div>
          <div class="team-container" [ngStyle]="{height: ((getMaxCount(team)) *11)+ 'rem'}"
            *ngIf="isApptAvailable(team, 'team', null)">
            <div *ngFor='let appointment of getApptForTeam(time.appointments,team)' class="appointment-container">
              <app-appointment-card [appointment]='appointment'></app-appointment-card>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="department === 'SALES' || department === 'PARTS'">
        <div *ngFor="let team of advisorList" style="margin: 5px;"
          [ngStyle]="{'background': getApptForAdvisor(time.appointments,team).length === 0 ? '#D1D2D333 0% 0% no-repeat padding-box' : 'white 0% 0% no-repeat padding-box' }">
          <div class="team-name" style="background-color: white;"
            [ngStyle]="{'display' : isApptAvailable(null, 'advisor', team) ? 'block' : 'none', 'height': i === currentSlide ? '' : '42px' }">
            {{ i === currentSlide ? getAdvisorDisplayName(team) : ''}} {{ i === currentSlide ? apptCountForAdvisor(team) : ''}}{{ i
            === currentSlide ? '/' + salesShopMaxSlot() : ''}} <span
              style="font-family: var(--font-family) ;"> {{i === currentSlide ? (apptCountForAdvisor(team) > 1 ? 
                ('serviceSchedule.slotsBooked' | translate) : ('serviceSchedule.slotBooked' | translate)) : ''}} </span>
            <span class="tooltiptext">{{ i === currentSlide ? getAdvisorDisplayName(team) : ''}} {{ i === currentSlide ?
              apptCountForAdvisor(team) : ''}}{{ i === currentSlide ? '/' + salesShopMaxSlot() :
              ''}} {{i === currentSlide ? ('serviceSchedule.slotsBooked' | translate) : ''}}</span>
          </div>
          <div class="team-container" [ngStyle]="{height: ((getMaxCountSales(team)) *10)+ 'rem'}"
            *ngIf="isApptAvailable(null, 'advisor', team)">
            <div *ngFor='let appointment of getApptForAdvisor(time.appointments,team)' class="appointment-container">
              <app-appointment-card [appointment]='appointment' [allInventoryVehicles] = 'allInventoryVehicles'></app-appointment-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="no-appointments" *ngIf='(appointmentsForDay?.length === 0)'>
    <mat-icon class="mat-icon">info_outline</mat-icon>
    <span class="label">{{ 'serviceSchedule.thereAreNoAppointmentsScheduledForTheDay' | translate }}</span>
  </div>
</div>
<button mat-icon-button id="date-button-next" (click)="onNext()">
  <mat-icon>keyboard_arrow_right</mat-icon>
</button>
<ng-template #loader>
  <div id="schedule-rotation-loader">
    <app-loading loadingSymbol="dots" text="{{'serviceSchedule.loadingAppointmentsForTheDay'| translate}}" color="var(--primary-sec-color)">
    </app-loading>
  </div>
</ng-template>